import cssVariables from 'tfs.css-variables'

export default {
  table: {
    // width: '100%',
    backgroundColor: cssVariables.colorWhite,
    fontSize: '0.87rem',
  },
  columns: {
    display: 'grid',
    gridAutoFlow: 'column',
    justifyItems: 'start',
    gridGap: '1rem',
    alignItems: 'center',
  },
  head: {
    padding: '0 2rem',
    boxShadow: '0 3px 5px -1px rgba(0,0,0,0.1)',
  },
  row: {
    padding: '1rem 2rem',
    display: 'grid',
    gridGap: '1rem',
    borderBottom: `1px solid ${cssVariables.colorGrayE}`,
    position: 'relative',

    '&:last-child': {
      border: 'none',
    },
  },
  rowStyledStates: {
    '&:hover': {
      backgroundColor: cssVariables.colorWhiteHover,
    },
  },
  rowActive: {
    backgroundColor: cssVariables.colorWhiteHover,
  },
  rowError: {
    backgroundColor: cssVariables.colorErrorBackgroundLight,
    transition: 'background-color 1s',

    '&:hover': {
      backgroundColor: cssVariables.colorErrorBackgroundLight,
    },
  },
  rowSuccess: {
    backgroundColor: cssVariables.colorSuccessBackgroundLight,
    transition: 'background-color 1s',
  },
  headCell: {
    fontWeight: 'normal',
    textAlign: 'left',
    padding: '1rem 0',
    color: cssVariables.colorGrayA,
  },
  cell: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  rounded: {
    borderRadius: '0 0 1em 1em',
  },

  // Controlled grid layout from elements itself
  // The gridTemplates for the BabyCells are set in FlightPassengers.styles.js
  tableCell: {
    display: 'inline-block',
  },

  // Specific Form-field widths
  checkbox: {
    width: '2rem',
  },
  number: {
    width: '1.5rem',
  },
  thirdPartyBookingNumber: {
    width: '11rem',
  },
  transaviaBookingNumber: {
    width: '5rem',
  },
  firstName: {
    width: '9rem',
  },
  lastName: {
    width: '12rem',
  },
  dateOfBirth: {
    width: '8rem',
  },
  gender: {
    width: '6rem',
  },
  luggage: {
    width: '6rem',
  },
  travelClass: {
    width: '4rem',
  },
  addSSR: {
    minWidth: '5rem',
  },
  addInfant: {
    minWidth: '8rem',
  },
}
